import { styled } from '@mui/material';

export const PlanPopupStyled = styled('div')({
  '.modal-dialog': {
    width: '836px',
  },
});